import React from 'react'
import './loader.scss'

const LoaderComponent: React.FC = () => (
  <div className='metlife-loading'>
    <div className="loading-spinner-wrapper">
      <div className="ml-loader">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className="ml-loader-label">
        <p>Loading...</p>
      </div>
    </div>
  </div>
)

export default LoaderComponent
